import React from 'react'

import './Footer.css'

const Footer = ({ globalSettings, socialSettings, navLinks }) => (
  <footer className="Footer">
    <div className="container taCenter">
      <span>© {new Date().getFullYear()} All rights reserved.</span>
    </div>
  </footer>
)

export default Footer
